import * as types from './types'

export default () => ({
  analysis: {
    orgId: null,
    challengeId: null,
    numWeeks: 1,
    evalOption: null,
    startDate: null,
    endDate: null,
    search: null,
  },
  activityProgress: [],
  bodyfatProgress: [],
  bodyweightProgress: [],
  challengeProgress: [],
  membershipProgress: [],
  nutritionProgress: [],
  dashboardProgress: [],
  members: [],
  isAllChecked: false,
})
